export default __webpack_public_path__ + "static/media/hotel3rdfloormap.7a8c166e.png";